import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Instagram, Play, Heart, Eye, ArrowUpRight } from "lucide-react";
import { getInstagram, px } from "../lib/api";
import { Reveal } from "./motion";

export default function InstaFeed() {
  const [data, setData] = useState({ reels: [], profile_url: "#", handle: "thekukkadco" });

  useEffect(() => {
    getInstagram().then(setData).catch(() => {});
  }, []);

  return (
    <section data-testid="instagram-section" className="relative border-y border-border bg-brown-deep overflow-hidden">
      <div className="absolute inset-0 footprint-bg opacity-[0.04] pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <Reveal className="flex flex-wrap items-end justify-between gap-4 mb-10">
          <div>
            <div className="flex items-center gap-2 text-orange">
              <Instagram className="w-5 h-5" />
              <span className="font-bold uppercase text-sm tracking-widest">Live from the ‘gram</span>
              <span className="flex items-center gap-1.5 ml-2 text-xs text-cream/50">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange opacity-75" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-orange" />
                </span>
                Auto-updating
              </span>
            </div>
            <h2 className="font-heading uppercase text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none mt-2">
              Fresh <span className="text-orange">reels</span>
            </h2>
          </div>
          <a
            href={data.profile_url}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-follow"
            className="flex items-center gap-2 bg-orange text-primary-foreground font-bold uppercase text-sm px-6 py-3.5 rounded-md hover:scale-105 transition-transform"
          >
            <Instagram className="w-4 h-4" /> @{data.handle}
          </a>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
          {data.reels.map((reel, i) => (
            <motion.a
              key={reel.id}
              href={reel.permalink}
              target="_blank"
              rel="noreferrer"
              data-testid={`instagram-reel-${reel.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 6) * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="group relative block aspect-[9/16] rounded-lg overflow-hidden border border-border"
            >
              <img
                src={px(reel.thumbnail, 500)}
                alt={reel.caption}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brown-deep via-brown-deep/10 to-transparent" />
              <div className="absolute top-2.5 right-2.5 w-8 h-8 rounded-full bg-brown/70 backdrop-blur-sm flex items-center justify-center">
                <Play className="w-3.5 h-3.5 text-cream fill-cream" />
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-brown-deep/50">
                <ArrowUpRight className="w-8 h-8 text-orange" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <div className="flex items-center gap-3 text-cream text-xs font-bold">
                  <span className="flex items-center gap-1"><Eye className="w-3.5 h-3.5" /> {reel.views}</span>
                  <span className="flex items-center gap-1"><Heart className="w-3.5 h-3.5" /> {reel.likes}</span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
